import React from "react";
import PropTypes from "prop-types";
import Navbar from "../../components/navbar/Navbar";
import { Container, styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const DashboardContainer = styled("div")(({ theme }) => ({
  width: "100vw",
  height: "100vh",
  position: "relative",
  display: "flex",
  flexDirection: "column",
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InsertProcessView = ({ isSolutecInsetable, isBlumosInsertable, handleExportProcess, isExporting }) => {
  return (
    <DashboardContainer>
      <Navbar />
      <Container maxWidth={"lg"}>
        <Box sx={{ width: "100%" }}>
          {isBlumosInsertable && (
            <>
              <Box py={2}>
                <Typography variant={"h5"}>Blumos</Typography>
                <Box display="flex" alignItems="center" gap={2}>
                  <Button variant="outlined" onClick={() => handleExportProcess(1000000)} disabled={isExporting}>
                    {isExporting ? "Exportando..." : "Exportar CSV"}
                  </Button>
                  {isExporting && <CircularProgress size={20} />}
                </Box>
              </Box>
            </>
          )}
          {isSolutecInsetable && (
            <>
              <Box py={2}>
                <Typography variant={"h5"}>Solutec</Typography>
                <Box display="flex" alignItems="center" gap={2}>
                  <Button variant="outlined" onClick={() => handleExportProcess(1000005)} disabled={isExporting}>
                    {isExporting ? "Exportando..." : "Exportar CSV"}
                  </Button>
                  {isExporting && <CircularProgress size={20} />}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Container>
    </DashboardContainer>
  );
};

InsertProcessView.propTypes = {
  isSolutecInsetable: PropTypes.bool.isRequired,
  isBlumosInsertable: PropTypes.bool.isRequired,
  handleExportProcess: PropTypes.func.isRequired,
  isExporting: PropTypes.bool
};

export default InsertProcessView;
